export default __webpack_public_path__ + "static/media/foodAndRestaurant.ef62530a.svg";